import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedDate } from 'react-intl';

const NewsCard = ({
	title, category, image, date, slug,
}) => (
	<section
		className="col-lg-4 col-md-4 col-sm-6 col-xs-12"
	>
		<Link to={`/news/${slug}`}>
			<div
				className="card"
			>
				{image.path && 	<div
					className="image"
					style={{
						backgroundImage: `url('${process.env.REACT_APP_API_ENDPOINT}/${
							image.path
						}')`,
					}}
				/>}
				{!image.path && <div
					className="image noImage"
				/>}
				<div className="description">
					<div className="date">
						<FormattedDate
							value={date}
							month="short"
							day="numeric"
							year="numeric"
						/>
					</div>
					<div className="title" style={{ '-webkit-box-orient': 'vertical' }}>
						{title}
					</div>
					<div>
						<span className="category">
							{category}
						</span>
					</div>
				</div>
			</div>
		</Link>
	</section>
);

export default NewsCard;
